/* tslint:disable */
/* eslint-disable */
/**
 * Location check service API
 * Service to centralise business area handling for multiple depending services.
 *
*/

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PositionRto
 */
export interface PositionRto {
    /**
     * 
     * @type {number}
     * @memberof PositionRto
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof PositionRto
     */
    longitude: number;
}

/**
 * Check if a given object implements the PositionRto interface.
 */
export function instanceOfPositionRto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "latitude" in value;
    isInstance = isInstance && "longitude" in value;

    return isInstance;
}

export function PositionRtoFromJSON(json: any): PositionRto {
    return PositionRtoFromJSONTyped(json, false);
}

export function PositionRtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionRto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function PositionRtoToJSON(value?: PositionRto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latitude': value.latitude,
        'longitude': value.longitude,
    };
}

